
export const SupplierTypes = [
  {
    id: 'BFFDF699-65EB-48D3-8681-BAEB7B452E2B',
    name: 'DX'
  },
  {
    id: '3BA5DE48-0185-48F5-9D3C-0D5C3D4972FB',
    name: 'ParcelForce'
  },
  {
    id: 'FDAA37FD-B1C9-4760-99E3-F4E10B979925',
    name: 'TPN'
  }
];

export function getSupplierName(supplierId: string): string {
  if (!supplierId) {
    return null;
  }
  const currentSupplier = SupplierTypes.find(s => s.id.toUpperCase() === supplierId.toUpperCase());
  if (currentSupplier) {
    return currentSupplier.name;
  }
  return null;
}
//export const SupplierTypes = [
//  {
//        id: '90730391-8C45-424A-A748-08D751EBB7AD',
//    name: 'DX'
//  },
//  {
//    id: '18e208a8-eded-427b-a41b-3bd8b3923fa6',
//    name: 'ParcelForce'
//  },
//  {
//    id: '44fc522b-11b8-4b2e-8e64-25b144e657ac',
//    name: 'TPN'
//  }
//];
